import { useMutation, useQueryClient } from "@tanstack/react-query";
import { settlementPoolBoostKeys } from "Api/Queries/Settlements/useGetSettlementPoolBoostsQuery";
import { poolTotalKeys } from "Api/Queries/Settlements/useGetPoolTotalQuery";
import {
  type UpdateSettlementPoolBoostRequest,
  type UpdateSettlementPoolBoostCommandResult,
  putSettlementPoolBoostsId,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type MutationVariables = {
  id: number;
  data: UpdateSettlementPoolBoostRequest;
};

type Props = {
  onSuccess?: (result: UpdateSettlementPoolBoostCommandResult) => void;
  onError?: (error: Error) => void;
};

export const useUpdateSettlementPoolBoostMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation<
    UpdateSettlementPoolBoostCommandResult,
    Error,
    MutationVariables
  >({
    mutationFn: processResponseWithApiProblemDetails(
      ({ id, data }: MutationVariables) => putSettlementPoolBoostsId(data, id),
    ),
    onSuccess: (result) => {
      queryClient.invalidateQueries({
        queryKey: settlementPoolBoostKeys.all,
      });
      queryClient.invalidateQueries({ queryKey: poolTotalKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
